import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Validador personalizado para arrays
 */
export class ArrayValidators {
  static required(control: AbstractControl): { [key: string]: boolean } | null {
    const value = control.value;

    // Invalido: Si no es un array o está vacío
    if (!Array.isArray(value) || value.length === 0) {
      return { required: true };
    }

    // Valido: Array con elementos
    return null;
  }

  static minLength(min?: number) {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      // Si no es array, lo tratamos como inválido
      if (!Array.isArray(value)) {
        return { minLengthArray: { requiredLength: min, actualLength: 0 } };
      }

      // Si tiene menos elementos de los requeridos
      if (value.length < min) {
        return {
          minLengthArray: {
            requiredLength: min,
            actualLength: value.length
          }
        };
      }

      return null;
    };
  }

}
